window.Vivense = window.Vivense || {};

Vivense.subScribe = (function($) {

    var exports = {},form;

    function subScribe() {
        $.ajax({
            url: '/ajax/user/insert_populate.php',
            method: 'POST',
            data: "scenario=" + scenario + "&page=" + page + "&from_action=" + from_action + "&design=" + design + "&user_action=" + user_action,
            cache: false
        }).done(function () {

        }).always(function () {
            if(callback){
                callback();
            }
        });
    }


    function submitForm(e) {

        e.preventDefault();

        var formData = $(this).serializeArray();

        formData.push({
            name : window.formToken,
            value : '1'
        });

        $.post('/ajax/user/subscribe.php', $.param(formData))
            .done(function (data) {
                if(data.success){


                    swal({
                        customClass: 'footer_subscribe_wrapper',
                        imageUrl: "//cdn.vivense.com/images/footer/icons/footer_subscribe_success.svg",
                        imageSize: '90x90',
                        title: "HOŞ GELDİN, KAYDINI BAŞARIYLA OLUŞTURDUK !",
                        confirmButtonText: "ALIŞVERİŞE BAŞLA >"


                    })
                }
            })
            .fail();

    }

    function init() {
        form = $('.footer-subscribe-form');

        form.each(function() {
            $(this).on('submit', submitForm);
        });

    }

    $(document).ready(init);

    exports.subScribe = subScribe;

    return exports;

})(jQuery);